import React from 'react';
import { Select, Form } from 'antd';

function PWCSelect(formItemInfo) {
  return (
    <Form.Item
      required={formItemInfo.required}
      name={formItemInfo.name}
      label={formItemInfo.label}
      rules={formItemInfo.rules}
      className={formItemInfo.className}
      style={formItemInfo.formItemStyle}
      // style={{ width: '100%', ...(formItemInfo?.formItemStyle || {}) }}
    >
      <Select
        placeholder="Select"
        className="select"
        dropdownClassName="select-dropdownmenu"
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        {...formItemInfo.compProps}
      />
    </Form.Item>
  );
}

export default PWCSelect;
